export default "__VITE_ASSET__tYwyZvb6__"